module.exports = __webpack_public_path__ + "img/angler-product.d3b59d67.png";